// extracted by mini-css-extract-plugin
export default {"aside":"WebinarsAside_aside__Cip14","item":"WebinarsAside_item__jMW8e","link":"WebinarsAside_link__XSdiz","name":"WebinarsAside_name__vK0Gu"};